import { useL10n } from '@uplift/hooks';
import { CheckboxWithLabel } from '@uplift/ui-v2';
import { useFormikContext } from 'formik';
import React, { Fragment, useCallback } from 'react';
import { AssessmentsContentBlock, FollowUpContentBlock, MapSessionFormFields, SectionContainerContent, SectionContainerDivider } from '../../components';
import { ClinicalNotesFormType } from '../../types';
import { useSectionStyles } from '../styles';

export const enum ConfirmRecommendationEnum {
  Continue = 'Continue following Treatment Plan',
  Edit = 'Edit Treatment Plan',
  Create = 'Create New Treatment Plan'
}

export const confirmRecommendations = [
  ConfirmRecommendationEnum.Edit,
  ConfirmRecommendationEnum.Create
];

// follow up progress
export const Progress: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useSectionStyles();
  const formik = useFormikContext<ClinicalNotesFormType>();

  const recommendationValue = formik.values.followUpProgress.recommendations as ConfirmRecommendationEnum;

  const withConfirmRecommendation = useCallback((input: React.ReactNode) => {
    const showCheckbox = confirmRecommendations.includes(recommendationValue);

    return (
      <Fragment>
        <SectionContainerContent>
          {input}
        </SectionContainerContent>
        {!showCheckbox && <SectionContainerDivider />}
        {showCheckbox && (
          <SectionContainerContent className={classes.greyBackground}>
            <CheckboxWithLabel
              color="secondary"
              name="recommendationConfirmation"
              label={l10n.clinicalNotes.recommendationConfirmation(recommendationValue.toLowerCase())}
              showError
            />
          </SectionContainerContent>
        )}
      </Fragment>
    );
  }, [ classes.greyBackground, l10n.clinicalNotes, recommendationValue ]);

  return (
    <>
      <AssessmentsContentBlock />
      <SectionContainerDivider />

      <MapSessionFormFields
        namespace="followUpProgress"
        sectioned
        targetFieldAndRender={{
          field: 'recommendations',
          ignoreSectioning: true,
          renderInput: withConfirmRecommendation
        }}
      />

      <FollowUpContentBlock />
    </>
  );
};
